export default __webpack_public_path__ + "static/media/jwaves even smaller.4a490538.jpg";